import React, { useState } from 'react';
import {
  Layout,
  Button,
  Select,
  Space,
  Typography,
  Row,
  Col,
  Card,
} from 'antd';
import Header from '../components/Header/header';
import { useNavigate } from 'react-router-dom';

const { Content } = Layout;
const { Title, Text } = Typography;

const NewHome = () => {
  const [curriculum, setCurriculum] = useState('Cambridge');
  const [language, setLanguage] = useState('');

  const curriculumOptions = [
    { value: 'Cambridge', label: 'Cambridge' },
    { value: 'IB', label: 'IB' },
    { value: 'CBSE', label: 'CBSE' },
    { value: 'ICSE', label: 'ICSE' },
  ];

  const languageOptions = [
    { value: '', label: 'Select Language' },
    { value: 'english', label: 'English' },
    { value: 'sinhala', label: 'Sinhala' },
    { value: 'tamil', label: 'Tamil' },
  ];

  const navigator = useNavigate();

  return (
    <Layout style={{ minHeight: '100vh', background: '#F2F2F7' }}>
      <Header />
      <Content style={{ marginTop: -3 }}>
        {/* Hero Section */}
        <div
          style={{
            backgroundImage: 'linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 50.48%, rgba(0, 0, 0, 0) 100%), url("/4.jpg")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            minHeight: 460,
            borderRadius: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            padding: '60px 20px',
            position: 'relative'
          }}
        >
          <Text style={{ color: '#fff', fontSize: 28,marginTop: 15 , marginBottom: 20, fontFamily: 'Regular' }}>
            My Home Tutor
          </Text>
          <Title
            level={1}
            style={{
              color: '#fff',
              fontSize: 56,
              textAlign: 'center',
              marginBottom: 40,
              marginTop: 10,
              maxWidth: 800,
              lineHeight: 1.2
            }}
          >
            A Comprehensive Home Learning Guide
          </Title>
          <Space size="large">
            <Button
              type="primary"
              size="large"
              style={{
                padding: '0 40px',
                height: 50,
                fontSize: 16,
                background: '#0781C4'
              }}
            >
              Become a member
            </Button>
            <Button
              size="large"
              onClick={() => navigator('/home')}
              style={{
                padding: '0 40px',
                height: 50,
                fontSize: 16,
                background: '#fff',
                color: '#0781C4',
                border: '1px solid #fff'
              }}
            >
              Take me to lessons
            </Button>
          </Space>
        </div>

        <Card style={{
          maxWidth: 1200,
          borderRadius: '20px',
          margin: '30px auto',
          boxShadow: 'var(--sds-size-depth-0) var(--sds-size-depth-025) var(--sds-size-depth-100) var(--sds-size-depth-0) var(--sds-color-black-100)',
          // boxShadow: 'var(--sds-size-depth-0) var(--sds-size-depth-025) var(--sds-size-depth-100) var(--sds-size-depth-0) var(--sds-color-black-200)'
        }} >
          <Title level={2} style={{ textAlign: 'center', color: '#0781C4', marginBottom: 16 }}>
            Access lessons across multiple curricula.
          </Title>
          <Text
            style={{
              textAlign: 'center',
              display: 'block',
              fontSize: 16,
              color: '#666',
              marginBottom: 40
            }}
          >
            Select your curriculum, language, and grade to explore all subjects with structured topics.
          </Text>

          <Row gutter={24} justify="center" align="middle">
            <Col xs={24} sm={8} md={6}>
              <div style={{ marginBottom: 16 }}>
                <Text strong style={{ display: 'block', marginBottom: 8, fontSize: 16 }}>
                  Curriculum
                </Text>
                <Select
                  value={curriculum}
                  onChange={setCurriculum}
                  options={curriculumOptions}
                  size="large"
                  style={{ width: '100%' }}
                />
              </div>
            </Col>
            <Col xs={24} sm={8} md={6}>
              <div style={{ marginBottom: 16 }}>
                <Text strong style={{ display: 'block', marginBottom: 8, fontSize: 16 }}>
                  Language
                </Text>
                <Select
                  value={language}
                  onChange={setLanguage}
                  options={languageOptions}
                  size="large"
                  style={{ width: '100%' }}
                  placeholder="Select Language"
                />
              </div>
            </Col>
            <Col xs={24} sm={8} md={4}>
              <div style={{ marginBottom: 16, marginTop: 28 }}>
                <Button
                  onClick={() => navigator('/home')}
                  type="primary"
                  size="large"
                  style={{
                    width: '100%',
                    background: '#0781C4',
                    height: 40
                  }}
                >
                  Continue
                </Button>
              </div>
            </Col>
          </Row>
        </Card>
      </Content>
    </Layout>
  );
};

export default NewHome;
